export const appSettingsGetTerritoriesWithFilters = "/app_settings/get_territories_with_filters";
